import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" {...this.props}><path d="M91.093 93.357H8.909c-2.987 0-5.372-2.182-6.547-4.217-1.176-2.035-.992-5.19.502-7.778L43.957 9.934c1.493-2.586 3.696-4.196 6.047-4.196 2.349 0 4.554 1.42 6.046 4.008l41.09 71.14c1.491 2.586 1.674 6.235.497 8.272-1.174 2.033-3.557 4.2-6.544 4.2zM50 9.831c-.802 0-1.673.715-2.392 1.96L6.515 82.964c-.72 1.245-.9 3.373-.502 4.068.403.694 1.458 2.106 2.894 2.106H91.09c1.435 0 2.49-1.412 2.893-2.106s.217-2.317-.502-3.56L52.393 12.044c-.719-1.245-1.591-2.213-2.393-2.213z" /><circle stroke="null" r="3.428" cy="73.937" cx="49.975" /><path stroke="null" d="M53.373 39.558a3.163 3.163 0 1 0-6.33 0v25.317a3.165 3.165 0 1 0 6.33 0V39.558z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/warning.svg